import _ from 'lodash'

const defaultState = {
  performances: {},
  markets: {},
  currencies: {},
  venues: {},
  tickets: {},
  deals: {},
  groups: {},
  eventGroups: {},
  partners: {},
  setupforms: {},
}

const unionArraysWithIdCheck = (originalArray, newValues) => {
  const resultArray = [...originalArray]
  for (let i = 0; i < newValues.length; i += 1) {
    const item = newValues[i]
    if (item.id != null) {
      let index
      while ((index = resultArray.findIndex(j => j.id === item.id)) >= 0) { // eslint-disable-line no-cond-assign
        resultArray.splice(index, 1)
      }
    } else {
      let index
      while ((index = resultArray.findIndex(j => j === item)) >= 0) { // eslint-disable-line no-cond-assign
        resultArray.splice(index, 1)
      }
    }
    resultArray.push(item)
  }
  return resultArray
}

const union = (objValue, srcValue) => {
  if (objValue === undefined) {
    return srcValue
  }

  if (srcValue === undefined) {
    return objValue
  }

  if (_.isArray(objValue) && _.isArray(srcValue)) {
    return unionArraysWithIdCheck(objValue, srcValue)
  }

  if (_.isObject(objValue) && _.isObject(srcValue)) {
    return _.mergeWith({}, objValue, srcValue, union)
  }

  return srcValue
}

const merge = (state, entities) => _.mergeWith({}, state, entities, union)

const unset = (state, deleteEntity) => _.unset(state, deleteEntity)

const replaceEntities = (state, entityMap) => {
  const modifiedState = { ...state }

  Object.keys(entityMap).forEach((entityType) => {
    modifiedState[entityType] = { ...modifiedState[entityType] }

    Object.keys(entityMap[entityType]).forEach((entityId) => {
      modifiedState[entityType][entityId] = entityMap[entityType][entityId]
    })
  })

  return modifiedState
}

export default (state = defaultState, action) => {
  if (action.response && action.response.entities) {
    return merge(state, action.response.entities)
  }

  if (action.response && action.response.replaceEntities) {
    return replaceEntities(state, action.response.replaceEntities)
  }

  if (action.response && action.response.deleteEntity) {
    unset(state, action.response.deleteEntity)
    return { ...state }
  }

  return state
}



/** WEBPACK FOOTER **
 ** ./src/reducers/entities/entities.js
 **/